import React, { useState } from "react";
import Navbar from "./Navbar";
import "./LoginPage.css";
import googleLogo from "../assets/google_logo.png"; // Google logo image

const LoginPage = () => {
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Login Submitted", loginData);
    // Integrate your login API or Firebase auth here
  };

  const handleGoogleLogin = () => {
    console.log("Google login clicked");
    // Integrate Google OAuth here
  };

  return (
    <div className="login-page">
      <Navbar />
      <main className="form-container">
        <h2>Login to Your Account</h2>

        {/* Google Login */}
        <button className="google-btn" onClick={handleGoogleLogin}>
          <img src={googleLogo} alt="Google logo" />
          Continue with Google
        </button>

        <p className="or-divider">OR</p>

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={loginData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={loginData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit">Login</button>
        </form>

        <div className="bottom-links">
          <p>
            Don't have an account? <a href="/register">Register here</a>
          </p>
          <p>
            <a href="/forgot-password">Forgot password?</a>
          </p>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
